import Vue from 'vue'
import { Toast } from '@didi/rich-ui'
import { i18n } from '@/common/utils/i18n'
Vue.use(Toast)
export function isObject(obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * 解析url参数
 * @example ?id=12345&a=b
 * @return Object {id:12345,a:b}
 */
export function urlParse() {
  const url = window.location.search
  const reg = /[?&][^?&]+=[^?&]+/g
  const arr = url.match(reg)
  const obj = {}
  if (arr) {
    arr.forEach(item => {
      const tempArr = item.substring(1).split('=')
      const key = decodeURIComponent(tempArr[0])
      const val = decodeURIComponent(tempArr[1])
      obj[key] = val
    })
  }
  return obj
}

/**
 * 把对象转换成key=val的url参数
 * @param obj
 * @param isEncode
 * @return {string}
 */
export function urlParams(obj, isEncode) {
  isEncode = isEncode !== false
  let url = ''
  if (isObject(obj)) {
    for (const k in obj) {
      const value = obj[k] !== undefined ? obj[k] : ''
      url += '&' + k + '=' + (isEncode ? encodeURIComponent(value) : value)
    }
  }
  return url ? url.substring(1) : ''
}

/**
 * 把平台英文转换为中文名
 * @param Array
 * @return {Array}
 */
export function platfrom2Chinese(enName) {
  let chName = ''
  switch (enName) {
    case 'baidu':
      chName = '百度'
      break
    case 'ele':
      chName = '饿了么'
      break
    case 'meituan':
      chName = '美团'
      break
  }
  return chName
}

/**
 * 将数组拆分成多个size长度的区块
 * @param array
 * @param size
 * @example chunk([1,2,3], 2) => [[1,2], [3]]
 * @return {array}
 */
export function chunk(array, size) {
  size = Math.max(size, 0)
  const length = array == null ? 0 : array.length
  if (!length || size < 1) {
    return []
  }
  let index = 0
  let resIndex = 0
  const result = new Array(Math.ceil(length / size))
  while (index < length) {
    result[resIndex++] = array.slice(index, (index += size))
  }
  return result
}

/**
 * 检查 value 是否为空
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 * isEmpty(null); // => true
 * isEmpty(false); // => true
 * isEmpty(0); // => true
 * isEmpty([1, 2, 3]); // => false
 * isEmpty({ 'a': 1 }); // => false
 */
export function isEmpty(v) {
  switch (typeof v) {
    case 'undefined':
      return true
    case 'string':
      if (v.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length === 0) {
        return true
      }
      break
    case 'boolean':
      if (!v) return true
      break
    case 'number':
      if (v === 0 || isNaN(v)) return true
      break
    case 'object':
      if (v === null || v.length === 0) return true
      // eslint-disable-next-line no-unreachable-loop
      for (const i in v) {
        return false
      }
      return true
  }
  return false
}

/**
 * Checks if `key` is a direct property of `object`.
 * @param {Object} object The object to query.
 * @param {string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 * @see hasIn, hasPath, hasPathIn
 * @example
 * const object = { 'a': { 'b': 2 } }
 * const other = create({ 'a': create({ 'b': 2 }) })
 * has(object, 'a') // => true
 * has(other, 'a') // => false
 */
export function has(object, key) {
  const hasOwnProperty = Object.prototype.hasOwnProperty
  return object != null && hasOwnProperty.call(object, key)
}

/**
 * 距离转换 米 -> 公里
 * distance < 1000 显示 500m 为单位
 * distance > 1000 显示  1.1km 为单位
 * @param {distance 距离 Number}
 * @param {unit 使用单位 : en / zh 默认英文单位结尾}
 * @returns {string}
 * @example
 * distanceParse(1100) => 1.1km
 * distanceParse(1250, 'zh') => 1.3公里
 * distanceParse(345) => 345m
 * distanceParse(345, 'zh') => 345米
 */
export function distanceParse(distance, unit = 'en') {
  const dis = +distance

  const UNIT_VALUE = {
    en: ['m', 'km'],
    zh: ['米', '公里'],
  }

  if (dis < 1000) {
    return `${dis}${UNIT_VALUE[unit][0]}`
  } else if (dis > 1000) {
    return `${(Math.round(distance / 100) / 10).toFixed(1)}${UNIT_VALUE[unit][1]}`
  }
  return ''
}
/**
 * 手机号 * 号隐藏 中间四位 或者 末尾四位
 * @param {value 手机号 String}
 * @param {type 格式化类型： type = 'mid' 中间四位， type = 'end' 最后四位}
 * @returns {string}
 * @example
 * phoneParse(17688889999) => 176****9999
 * phoneParse(17600333628, 'end') => 1760033****
 * phoneParse(17600333628, 'mid', '#') => 176####3628
 */
export function phoneParse(value, type = 'mid', replace = '*') {
  const mobile = value + ''
  let replaceStr = ''
  let str = ''
  let reg = /(\d{3})\d{4}(\d{4})/

  for (let i = 0; i < 4; i++) {
    replaceStr += replace.trim()
  }

  if (type === 'end') {
    reg = /(\d{7})(\d{4})/
    str = `$1${replaceStr}`
  } else {
    str = `$1${replaceStr}$2`
  }
  return mobile.trim().replace(reg, str)
}

/**
 * @param  {[type]} date [description]
 * @param  {[type]} fmt  [description]
 * @return {[type]}      [description]
 * @example
 * formatDate(dateString, 'YMd') => 20180210
 * formatDate(dateString, 'Y-M-d') => 2018-02-10
 */
export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  const o = {
    'Y+': date.getFullYear(),
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
    }
  }
  return fmt
}

/**
 * 空闲控制 返回函数连续调用时，空闲时间必须大于或等于 wait，func 才会执行
 * @param  {function} func        传入函数
 * @param  {number}   wait        表示时间窗口的间隔
 * @param  {boolean}  immediate   设置为ture时，调用触发于开始边界而不是结束边界
 * @return {function}             返回客户调用函数
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = new Date().getTime() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function () {
    context = this
    args = arguments
    timestamp = new Date().getTime()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

export function url2localProtocol(url = '') {
  if (Array.isArray(url)) {
    url = url[0]
  }
  url = url || ''
  if (typeof url === 'object' && url.url && typeof url.url === 'string') {
    url = url.url
  }
  if (typeof url !== 'string') {
    console.log(`url类型错误： ${url}`)
    return
  }
  const match = url.match(/^(http|https):(.*)/)
  if (match) {
    return location.protocol + match[2]
  } else {
    return url
  }
}

// 图床资源
// ① 4:3 [240x180, 320x240, 480x360, 960x720]
// ② 1: 1[240x240, 320x320, 480x480, 960x960]
// _m 表示等比例缩放
export function imageCut(url, ratio, isEqual = true) {
  return isEqual ? `${url}!${ratio}_m` : `${url}!${ratio}`
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

export function doNothing() {}

export function getShopExpireInfo(day) {
  if (day === undefined || day === '' || day === null) {
    return false
  }
  if (+day < 0) {
    return {
      title: '已过期',
      type: 'error',
    }
  }
  if (+day === 0) {
    return {
      title: '今天过期',
      type: 'warning',
    }
  }
  if (+day <= 60 && +day > 0) {
    return {
      title: `${+day}天后过期`,
      type: 'warning',
    }
  }
}

/**
 * fromName数组中的某一个页面 跳转到 toPath页面需要使用缓存数据
 * @param toObj beforeEach钩子的to对象
 * @param routerQueue 当前路由的数组
 * @param toPath 需要使用缓存数据的页面path
 * @param fromName 从何处来需要做缓存，数组形式
 * @param mutationMethod 触发的mutation的方法名字
 * @param store 当前的store
 */
export function replyPathChangeIsRefersh({
  toObj,
  routerQueue,
  toPath,
  fromName,
  mutationMethod,
  store,
}) {
  let flagResult = true
  if (toObj.path === toPath) {
    flagResult = !(routerQueue.length === 1 && fromName.includes(routerQueue[0]))
    store.commit(mutationMethod, flagResult)
  }
}

/**
 * 如果有复制功能则提示复制成功，否则提示暂不支持
 * @param content
 */
export function copyContent(content) {
  if (isInFlutterHost() && window.Soda.copyText) {
    try {
      window.Soda.copyText({ text: content })
      Toast.$create({
        txt: i18n.gettext('复制成功'),
        time: 1000,
        type: 'txt',
      }).show()
    } catch {}

    return
  }
  const node = document.createElement('textarea')
  node.value = content || ''
  document.body.appendChild(node)
  node.select()
  if (document.execCommand('Copy')) {
    document.execCommand('Copy')
    Toast.$create({
      txt: i18n.gettext('复制成功'),
      time: 1000,
      type: 'txt',
    }).show()
  } else {
    Toast.$create({
      txt: i18n.gettext('暂不支持复制功能'),
      time: 1000,
      type: 'txt',
    }).show()
  }
  document.body.removeChild(node)
}

/**
 * 判断是否为处在flutter_webview
 */

export function isInFlutterHost() {
  return navigator.userAgent.indexOf('FlutterWebView') > -1
}

/**
 * 比较版本号大小
 * 如果 version1 > version2 返回 1，如果 version1 < version2 返回 -1，除此之外返回 0。
 */
export function compareVersion(version1, version2) {
  const v1 = version1.split('.')
  const v2 = version2.split('.')
  let index = 0
  while (index < v1.length || index < v2.length) {
    if (!v2[index]) {
      v2[index] = 0
    }
    if (!v1[index]) {
      v1[index] = 0
    }
    if (+v1[index] < +v2[index]) {
      return -1
    } else if (+v1[index] > +v2[index]) {
      return 1
    } else {
      index++
    }
  }
  return 0
}
// 处理成小写
export function responseLower(response) {
  const entriesArr = Object.entries(response)
  const newResult = {}
  entriesArr.forEach(([key, value]) => {
    newResult[key.toLowerCase()] = value
  })
  return newResult
}
